import { render, staticRenderFns } from "./fusion.vue?vue&type=template&id=8c27adb0&scoped=true&"
import script from "./fusion.vue?vue&type=script&lang=js&"
export * from "./fusion.vue?vue&type=script&lang=js&"
import style0 from "./fusion.vue?vue&type=style&index=0&id=8c27adb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c27adb0",
  null
  
)

component.options.__file = "fusion.vue"
export default component.exports